// eslint-disable-next-line @typescript-eslint/ban-types
type Checker = Function & { isRequired?: Checker }

export const getPropDescriptor = (
  propName: string,
  componentName: string,
  location: string,
  propFullName: string
): string =>
  `${location} \`${propFullName || propName}\` in \`${componentName}\``

const isRequired: Checker = (
  props: object,
  propName: string,
  componentName: string,
  location: string,
  propFullName: string
): Error | undefined => {
  // @ts-ignore
  const value = props[propName]
  if (value == null) {
    const propDesc = getPropDescriptor(
      propName,
      componentName,
      location,
      propFullName
    )
    return new Error(
      `The ${propDesc} is marked as required, but its value is \`${value}\`.`
    )
  }

  return undefined
}

export const chainCustomCheckers = (checkers: Array<Checker>): Checker => {
  return (
    props: object,
    propName: string,
    componentName: string,
    location: string,
    propFullName: string
  ): Error | undefined => {
    for (let i = 0; i < checkers.length; i += 1) {
      const error = checkers[i](
        props,
        propName,
        componentName,
        location,
        propFullName
      )
      if (error) {
        return error
      }
    }

    return undefined
  }
}

export const addIsRequiredChecker = (checker: Checker): Checker => {
  checker.isRequired = chainCustomCheckers([isRequired, checker])
  return checker
}
